// Registers the Ovamx service worker for PWA install + offline cache.
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Avoid SW in dev — CRA dev server's webpack overlay/HMR fights with caching.
  const isLocal =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (isLocal) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info("[Ovamx PWA] service worker registered", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[Ovamx PWA] sw register failed", err);
      });
  });
}
